import { Directive, Input, HostListener } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[lxPhonePrefixSanitizer]',
})
export class PhonePrefixSanitizerDirective {
  @Input('lxPhonePrefixSanitizer') prefixes: string[] = [];

  @HostListener('change', ['$event'])
  onChange(event: Event): void {
    const target = event.target;
    if (target instanceof HTMLInputElement) {
      this.stripPrefixIfNeeded(target);
    }
  }

  private stripPrefixIfNeeded(inputEl: HTMLInputElement): void {
    if (!inputEl || !this.prefixes?.length) {
      return;
    }

    const currentValue = inputEl.value;
    const prefixToRemove = this.prefixes.find((prefix) => currentValue.startsWith(prefix));
    if (currentValue && prefixToRemove) {
      inputEl.value = currentValue.substring(prefixToRemove.length);
      inputEl.dispatchEvent(new Event('input', { bubbles: true }));
      inputEl.dispatchEvent(new Event('blur', { bubbles: true }));
    }
  }
}
